
export const packageColumns = [
    { key: "luxury", title: "Luxury", price: "2299" },
    { key: "standard", title: "Standard", price: "2150" },
    { key: "basic", title: "Basic", price: "1999" },
];

export const packageSections = [
    {
        number: 1,
        title: "Structure",
        rows: [
            {
                label: "Basement height",
                luxury: "Upto 3.5 feet",
                standard: "Upto 3 feet",
                basic: "Upto 2.5 feet",
            },
            {
                label: "Steel",
                luxury: "Isteel",
                standard: "ARS",
                basic: "Any ISI brand",
            },
            {
                label: "Bricks",
                luxury: "Wirecut bricks",
                standard: "Chamber bricks",
                basic: "Fly ash bricks",
            },
            {
                label: "Cement",
                luxury: "Ultratech/Ramco",
                standard: "Chettinad",
                basic: "Penna",
            },
            {
                label: "Sand for Brick work",
                luxury: "M-Sand",
                standard: "M-Sand",
                basic: "M-Sand",
            },
            {
                label: "Sand for Plastering",
                luxury: "River Sand",
                standard: "P-Sand",
                basic: "P-Sand",
            },
            {
                label: "Concrete grade",
                luxury: "M20 (Manual mix)",
                standard: "M20 (Manual mix)",
                basic: "M20 (Manual mix)",
            },
            {
                label: "Ceiling height",
                luxury: "10 Feet",
                standard: "10 Feet",
                basic: "10 Feet",
            },
            {
                label: "Parapet wall",
                luxury: "4 Feet height",
                standard: "4 Feet height",
                basic: "3.5 Feet height",
            },
        ],
    },
    {
        number: 2,
        title: "Tiles",
        rows: [
            {
                label: "Living, Kitchen & Dining area",
                luxury: "4×2' - Verified tile",
                standard: "2×2' - Verified tile",
                basic: "2×2' - Verified tile",
            },
            {
                label: "Toilet wall tile",
                luxury: "Upto ceiling",
                standard: "Upto 7 feet",
                basic: "Upto 7 feet",
            },
            {
                label: "Staircase",
                luxury: "Tile - 3'×1'",
                standard: "Tile - 3'×1'",
                basic: "Tile - 1'×1'",
            },
        ],
    },
    {
        number: 3,
        title: "Painting",
        rows: [
            {
                label: "Internal",
                luxury: "Asian - Royal",
                standard: "Asian - Premium",
                basic: "Asian - Tractor emulsion",
            },
            {
                label: "External",
                luxury: "Asian - Apex",
                standard: "Asian - Ace advance",
                basic: "Asian - Ace",
            },
        ],
    },
    {
        number: 4,
        title: "Plumbing",
        rows: [
            {
                label: "Internal lines",
                luxury: "CPVC - Ashirvaad",
                standard: "CPVC - Ashirvaad",
                basic: "CPVC - Ashirvaad",
            },
            {
                label: "External lines",
                luxury: "PVC - Finolex",
                standard: "PVC - Supreme",
                basic: "PVC - Neroplast",
            },
        ],
    },
    {
        number: 5,
        title: "Electrical",
        rows: [
            {
                label: "Wires",
                luxury: "Finolex / Polycab",
                standard: "Orbit",
                basic: "Orbit",
            },
            {
                label: "Switches",
                luxury: "Legrand",
                standard: "GM",
                basic: "Anchor roma",
            },
        ],
    },
    {
        number: 6,
        title: "Doors & Windows",
        rows: [
            {
                label: "Windows",
                luxury: "UPVC - ISI - Rs 750/sq.ft",
                standard: "UPVC - ISI - Rs 500/sq.ft",
                basic: "UPVC - ISI - Rs 350/sq.ft",
            },
            {
                label: "Main door",
                luxury:
                    'Size - 3\' 6" × 7\' 0" - 1st class Teak wood frame of size 5" × 3" and shutter of Teak wood',
                standard:
                    'Size - 3\' 6" × 7\' 0" - 1st class Teak wood frame of size 5" × 3" and shutter of Teak wood',
                basic:
                    'Size - 3\' 6" × 7\' 0" - 1st class Teak wood frame of size 5" × 3" and shutter of Teak wood',
            },
            {
                label: "Bedroom doors",
                luxury:
                    'Size - 3\' 0" × 7\' 0" - 2nd Quality - African Teak wood frame of size - 4" × 3" and laminated flush door',
                standard:
                    'Size - 3\' 0" × 7\' 0" - 2nd Quality - African Teak wood frame of size - 4" × 3" and laminated flush door',
                basic:
                    'Size - 3\' 0" × 7\' 0" - 2nd Quality - African Teak wood frame of size - 4" × 3" and laminated flush door',
            },
            {
                label: "Toilet doors",
                luxury: "WPC Frame & Door",
                standard: "WPC Frame & Door",
                basic: "PVC Door",
            },
        ],
    },
    {
        number: 7,
        title: "Anti-Terminate",
        rows: [
            {
                label: "Treatment",
                luxury:
                    "Done at Basement and During fixing of all wooden frames",
                standard:
                    "Done at Basement and During fixing of all wooden frames",
                basic:
                    "Done at Basement and During fixing of all wooden frames",
            },
        ],
    },
];